import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/header-banner.jpg';
import { Helmet } from 'react-helmet-async';


function ELearning() {
return (
    <div >
      <Helmet>
              <title>E-learning | State Board of Secondary Education, Delhi</title>
              <meta
                name="description"
                content="Learn more about the E-learning initiatives at the State Board of Secondary Education, Delhi."
              />
               <meta
          name="keywords"
          content="State Board of Secondary Education, Delhi, education, literacy, initiatives"
        />
            </Helmet>
    
    <Header/>
    {/* <Showlist/> */}
    <div className='container'>
        <div className='about-banner'>
            <img src={aboutBanner} alt=""/>
             <h1 className='page-title'>E-Learning</h1>
        </div>
    </div>
    
    <div className='container main-contant'>
      <div className='inner-page-container'>  
      <div className="content-secion text-center">
          <h1>Coming Soon</h1>
</div>
      </div>
    
    </div>
    <Footer/>
     </div>
    )
}

export default  ELearning;
